<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">

            <br />
            <CAlert color="success" v-if="SuccessMessage ===true" class="mt-2">{{ Message }}</CAlert>
            <CAlert color="danger" v-if="Error ===true" class="mt-2">{{ Message }}</CAlert>
            <div style="margin: 0px 20px;">
              <h4 style="color: #000; text-align: left" class="custom-user-grade">
                Name
              </h4>
              <form class="ml-3 mr-3">
                <input
                  type="text"
                  class="custom-input-user"
                  placeholder="eg. Nazhan"
                  v-model="parent.userName"
                  disabled
                />
              </form>            

              <h4 style="color: #000; text-align: left" class="custom-user-grade">
                Email
              </h4>
              <form class="ml-3 mr-3">
                <input
                  type="text"
                  class="custom-input-user"
                  placeholder="eg. aliff.syukri@gmail.com"
                  v-model="parent.userEmail"
                  disabled
                />
              </form>  

              <h4 style="color: #000; text-align: left" class="custom-user-grade">
                Phone Number
              </h4>
              <form class="ml-3 mr-3">
                <div class="icon-custom-listphone">
                  <input
                    type="number"
                    class="custom-input-user"
                    placeholder="0102345678"
                    v-model="parent.phoneNumber"
                    disabled
                  />
                </div>
              </form>

              <div class="bottom-center">
                <CButton style="
                  position: fixed;
                  bottom: 30px;
                  left: 0px;
                  right: 0px;
                  text-align: center;
                  margin: 0 auto;" 
                  class="btn-select-blue" 
                  @click="InsertInfo()">
                    Next
                </CButton>
              </div>
            </div>
            
              

          </div>
        </div>
      </div>
    </CContainer>
    
    <div class="header-top">Basic Information</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
   data: function () {
    return {
      user: {},
      parent: {},

      // name: "",
      // email: "",
      // phone: "",
      data: "",
      Error: false,
      Message: "",
      SuccessMessage: false

    };
  },

  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetParentProfile(this.user.id);
          }
        });
    },

    GetParentProfile() {
    this.$API
      .get(this.$ParentProfile + "?userId=" + this.user.id, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.parent = response.data;
        }
      });
    },

    InsertInfo(){
      const formData = new FormData();

      formData.append("name", this.parent.userName);
      formData.append("email", this.parent.userEmail);
      formData.append("phone", this.parent.phoneNumber);

      return this.$API
        .post(this.$RegisterTutors, formData, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response.status);
          // console.log(response.data);
          if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
          if (response.status == 200) { 
            this.data = response.data;    
            console.log("data", this.data);
            this.teacherId = this.data.teacherId;       
           this.Message = response.data.Message;
             this.SuccessMessage = true;
            this.GoToSchool(this.teacherId);
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });

      
    },

    GoToSchool(teaId) {
      this.$router.push(
        "BTSelectSchool?teacherId=" +
        teaId
      );
    },

    GoBack() {
     this.$router.back();
    },
  }
}
</script>

 


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 100%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.custom-user-input {
  /* Body/1/Semibold */

 display: flex;
  justify-content: center;
  flex-flow: row nowrap;

}

.custom-user-inputs {
    display: flex;
    display: -ms-flexbox;
    /* display: -webkit-box; */
    /* -webkit-box-pack: center; */
    -ms-flex-pack: center;
    justify-content: center;
    /* -webkit-box-orient: horizontal; */
    /* -webkit-box-direction: normal; */
    -ms-flex-flow: row nowrap;
    /* flex-flow: row nowrap; */
    width: -webkit-fill-available;
}

</style>